module.exports = __webpack_public_path__ + "static/images/styles/images/reserves/additional-briefing-clan-landing-sm.78eef1a9.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/reserves/additional-briefing-clan-landing-sm.png
// module id = 3689
// module chunks = 11